module.exports = __webpack_public_path__ + "static/media/back-btn.c4352e96.svg";